module.exports = __webpack_public_path__ + "img/xl_hn.416ac492.png";